declare module 'blakejs/blake2b.js' {
  export {
    Blake2bCTX,
    blake2bInit,
    blake2bUpdate,
    blake2bFinal,
    blake2b,
    blake2bHex,
  } from 'blakejs';
}
